import { Fragment } from '@wordpress/element';
import { InspectorControls, MediaUpload } from '@wordpress/block-editor';
import { PanelBody, Button, ToggleControl } from '@wordpress/components';
import { createHigherOrderComponent } from '@wordpress/compose';
import { addFilter } from '@wordpress/hooks';
import classnames from 'classnames';

const withMobileImage = createHigherOrderComponent((BlockEdit) => {
    return (props) => {
        if (props.name !== 'core/cover') {
            return <BlockEdit {...props} />;
        }

        const { attributes, setAttributes } = props;
        const { overlayHeader, mobileImageUrl, mobileVideoUrl} = attributes;

        return (
            <Fragment>
                <BlockEdit {...props} />
                <InspectorControls>
                    <PanelBody title="🟩 Settings" initialOpen={true}>
                        <ToggleControl
                            label="Do you want all header menus to overlay with the cover?"
                            checked={!!overlayHeader}
                            onChange={() => setAttributes({ overlayHeader: !overlayHeader })}
                        />
                    </PanelBody>
                    <PanelBody title="🟩 Image" initialOpen={true}>
                        <div class="hc-supernormal-s">Upload image for mobile</div><br/>
                        <MediaUpload
                            onSelect={(media) => setAttributes({ mobileImageUrl: media.url })}
                            allowedTypes={['image']}
                            value={mobileImageUrl}
                            render={({ open }) => <Button className="hc-border-brightness-60" onClick={open}>Choose Image</Button>}
                        />
                        {mobileImageUrl && (
                            <div>
                                <Button
                                    isLink
                                    isDestructive
                                    onClick={() => setAttributes({ mobileImageUrl: undefined })}
                                >
                                    Remove Image
                                </Button>
                                <img src={mobileImageUrl} style={{ width: '100%', marginTop: '10px' }} />
                            </div>
                        )}
                    </PanelBody>
                    <PanelBody title="🟩 Video" initialOpen={true}>
                        <div class="hc-supernormal-s">Upload video for mobile</div><br />
                        <MediaUpload
                            onSelect={(media) => setAttributes({ mobileVideoUrl: media.url })}
                            allowedTypes={['video']}
                            value={mobileVideoUrl}
                            render={({ open }) => <Button className="hc-border-brightness-60" onClick={open}>Choose Video</Button>}
                        />
                        {mobileVideoUrl && (
                            <div>
                                <Button
                                    isLink
                                    isDestructive
                                    onClick={() => setAttributes({ mobileVideoUrl: undefined })}
                                >
                                    Remove Video
                                </Button>
                                <video src={mobileVideoUrl} style={{ width: '100%', marginTop: '10px' }} />
                            </div>
                        )}
                    </PanelBody>
                </InspectorControls>
            </Fragment>
        );
    };
}, 'withMobileImage');

/**
    * Add custom element class in save element.
    *
    * @param {Object} extraProps     Block element.
    * @param {Object} blockType      Blocks object.
    * @param {Object} attributes     Blocks attributes.
    *
    * @return {Object} extraProps Modified block element.
    */
function applyExtraClass(extraProps, blockType, attributes) {

    const { overlayHeader, mobileImageUrl, mobileVideoUrl } = attributes;
    const allowedBlocks = ['core/cover'];

    //check if attribute exists for old Gutenberg version compatibility
    //add allowedBlocks restriction
    if (allowedBlocks.includes(blockType.name)) {
        if (overlayHeader === true) {
            extraProps.className = classnames(extraProps.className, 'hc-overlay-header-on-cover');
        } else {
            extraProps.className = classnames(extraProps.className.replace('hc-overlay-header-on-cover', ''));
        }

        if (mobileImageUrl) {
            extraProps['data-mobile-image-url'] = mobileImageUrl;
        }

        if (mobileVideoUrl) {
            extraProps['data-mobile-video-url'] = mobileVideoUrl;
        }
    }
    return extraProps;
}

addFilter(
    'editor.BlockEdit',
    'humane/add-video-and-image',
    withMobileImage
);

// Register new attribute for mobile image URL
// Register new attributes
addFilter(
    'blocks.registerBlockType',
    'humane/add-video-and-image-attributes',
    (settings, name) => {
        if (name !== 'core/cover') {
            return settings;
        }

        return {
            ...settings,
            attributes: {
                ...settings.attributes,
                mobileImageUrl: {
                    type: 'string',
                    default: ''
                },
                mobileVideoUrl: {
                    type: 'string',
                    default: ''
                },
                overlayHeader:{
                    type: 'boolean',
                    default: false
                }
            }
        };
    }
);

addFilter(
    'blocks.getSaveContent.extraProps',
    'humane/applyExtraClass',
    applyExtraClass
);

export default withMobileImage;
